/**
 * AUTOGENERATED, DO NOT EDIT!
 *
 * https://gitlab.com/digital-pharma-tools/open-api-codegen
 *
 */
export enum ReferencePricePresentationEnum {
    SHOW_NOTIFICATION_NO_PRICE = 'SHOW_NOTIFICATION_NO_PRICE',
    SHOW_NOTIFICATION_AND_REF_PRICE = 'SHOW_NOTIFICATION_AND_REF_PRICE',
    NO_NOTIFICATION_REF_PRICE_AS_NORMAL_PRICE = 'NO_NOTIFICATION_REF_PRICE_AS_NORMAL_PRICE',
}